import axios from 'axios';

// API URLを動的に取得
export const getApiUrl = () => {
  // デバッグ用ログ
  console.log('getApiUrl - VITE_API_URL:', import.meta.env.VITE_API_URL);
  console.log('getApiUrl - hostname:', window.location.hostname);

  // 環境変数が設定されている場合は優先
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  const hostname = window.location.hostname;

  // line.wa-ton.comドメイン（HTTPS）- 最初にチェック
  if (hostname === 'line.wa-ton.com' || hostname.endsWith('.wa-ton.com')) {
    console.log('getApiUrl - Using line.wa-ton.com HTTPS URL');
    return 'https://line.wa-ton.com/api';
  }

  // カツ氏本番VPS環境（先にチェック） - 2025/09/22修正
  if (hostname === '210.131.211.206') {
    console.log('getApiUrl - Using VPS URL');
    return 'http://210.131.211.206:3001/api';
  }

  // ローカル開発環境 - VPS環境では使わない
  if ((hostname === 'localhost' || hostname === '127.0.0.1') && window.location.port === '3002') {
    console.log('getApiUrl - Using localhost URL');
    return 'http://localhost:3001/api';
  }

  // wa-ton.comドメイン
  if (hostname === 'wa-ton.com' || hostname === 'www.wa-ton.com') {
    return 'https://wa-ton.com/api';
  }

  // XVPSテスト環境（R氏）
  if (hostname === '210.131.219.65') {
    return 'http://210.131.219.65:3001/api';
  }

  // デフォルト（同じホストの3001ポート）
  // HTTPSページからアクセスしている場合はHTTPSを使用（ポートなし）
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  // HTTPSの場合は必ずポートなし、HTTPの場合のみ3001ポート
  const port = protocol === 'https' ? '' : ':3001';
  console.log('getApiUrl - Default case, protocol:', protocol, 'port:', port);
  return `${protocol}://${hostname}${port}/api`;
};

export const getBackendUrl = () => {
  // 環境変数が設定されている場合は優先
  if (import.meta.env.VITE_BACKEND_URL) {
    return import.meta.env.VITE_BACKEND_URL;
  }

  const hostname = window.location.hostname;

  // line.wa-ton.comドメイン（HTTPS）- 最初にチェック
  if (hostname === 'line.wa-ton.com' || hostname.endsWith('.wa-ton.com')) {
    console.log('getBackendUrl - Using line.wa-ton.com HTTPS URL');
    return 'https://line.wa-ton.com';
  }

  // カツ氏本番VPS環境（先にチェック）
  if (hostname === '210.131.211.206') {
    return 'http://210.131.211.206:3001';
  }

  // ローカル開発環境
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }

  // wa-ton.comドメイン
  if (hostname === 'wa-ton.com' || hostname === 'www.wa-ton.com') {
    return 'https://wa-ton.com';
  }

  // XVPSテスト環境（R氏）
  if (hostname === '210.131.219.65') {
    return 'http://210.131.219.65:3001';
  }

  // デフォルト（同じホストの3001ポート）
  // HTTPSページからアクセスしている場合はHTTPSを使用
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const port = protocol === 'https' ? '' : ':3001';
  return `${protocol}://${hostname}${port}`;
};

// デフォルトのaxiosインスタンス
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Cookieを含めて送信
});

// リクエスト時に動的にbaseURLを設定とトークン追加
apiClient.interceptors.request.use((config) => {
  // 毎回最新のURLを取得
  const baseURL = getApiUrl();

  console.log('apiClient interceptor - Original URL:', config.url);
  console.log('apiClient interceptor - Base URL:', baseURL);

  // URLが相対パスの場合はbaseURLを追加
  if (config.url && !config.url.startsWith('http')) {
    config.url = baseURL + config.url;
  }

  console.log('apiClient interceptor - Final URL:', config.url);

  // トークンを自動追加
  const token = localStorage.getItem('waton_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default apiClient;